<template>
  <div style="margin-top: 113px">
    <template>
      <v-container>
        <v-snackbar v-model="error" color="red darken-2">
          <b>{{ errorMessage }} </b>
        </v-snackbar>
        <h1 v-if="this.bilans.length > 0">
          Manager Bilans ({{ bilans.length }} {{ plural }})
        </h1>
        <h1 v-else>Manager Bilans</h1>
        <v-card>
          <v-card-title>
            <v-col class="d-flex" cols="4">
              <v-select
                :items="campaignsItems"
                v-model="year"
                @change="loadBilans"
              >
              </v-select>
            </v-col>
            <v-col class="d-flex" cols="5">
              <v-text-field
                v-model="filter"
                label="Filter on first name or last name"
                @keyup="filterBilan($event)"
                @click="filterBilan($event)"
              ></v-text-field>
            </v-col>
          </v-card-title>
          <v-card-text v-if="this.bilans.length < 1">
            <div class="ml-8">
              <h3 style="color:#757575; text-align:center">
                Aucun bilan pour votre équipe / no bilan for your team
              </h3>
            </div>
          </v-card-text>
          <v-card-text v-else>
            <v-data-table
              :headers="headers"
              :items="bilans"
              sort-by="firstName"
            >
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn text icon v-on="on" :to="'/managerBilan/' + item.id">
                      <v-icon
                        v-if="item.status.code == 'MAN_PROP'"
                        color="red"
                        small
                        class="mr-2"
                      >
                        mdi-lead-pencil
                      </v-icon>
                      <v-icon v-else small class="mr-2">
                        mdi-lead-pencil
                      </v-icon>
                    </v-btn>
                  </template>
                  <span v-if="item.status.code == 'MAN_PROP'">Edit bilan</span>
                  <span v-else>Show bilan </span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-container>
    </template>
  </div>
</template>

<style scoped>
.btn-action:hover {
  cursor: pointer;
  color: #00695c !important;
}
</style>

<script>
import { mapGetters } from "vuex";
export default {
  name: "bilanteam",
  data() {
    return {
      headers: [
        { text: "First name", value: "user.firstName" },
        { text: "last name", value: "user.lastName" },
        { text: "Status", value: "status.label" },
        { text: "Year", value: "campaignBilan.year" },
        { text: "Company entry date", value: "user.companyEntryDate" },
        { text: "Manager", value: "manager" },
        { text: "Company", value: "user.company.label" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      bilans: [],
      plural: null,
      error: false,
      errorMessage: "",
      filter: "",
      year: new Date().getFullYear(),
      campaignsBilans: [],
      campaignsItems: [],
      filteredBilans: [],
      originalBilans: [],
    };
  },
  computed: {
    ...mapGetters({
      getCampaign: "getCampaign",
      getCampaigns: "getCampaigns",
      user: "auth/user",
    }),
  },
  methods: {
    puntInPlural() {
      if (this.bilans.length < 2) {
        this.plural = "bilan";
      } else {
        this.plural = "bilans";
      }
    },
    filterBilan: function() {
      if (!this.filter || this.filter.length == 0) {
        this.resetFilter();
      } else {
        this.resetFilter();
        this.filteredBilans = [];
        this.bilans.forEach((bilan) => {
          if (
            bilan.user.firstName
              .toLowerCase()
              .includes(this.filter.toLowerCase()) ||
            bilan.user.lastName
              .toLowerCase()
              .includes(this.filter.toLowerCase())
          ) {
            this.filteredBilans.push(bilan);
          }
        });
        this.bilans = this.filteredBilans;
        this.puntInPlural();
      }
    },
    resetFilter: function() {
      this.bilans = this.originalBilans;
      this.puntInPlural();
    },
    loadBilans: function() {
      fetch(
        process.env.VUE_APP_ROOT_API_PATH + "api/bilans/manager/" + this.year,
        {
          method: "GET",
          credentials: "include",
        }
      )
        .then((response) => {
          if (response.status == "200") {
            return response.json();
          }
        })
        .then((json) => {
          if (json) {
            this.bilans = json.data;

            this.bilans.forEach(function(bilan) {
              var managerFirstName =
                bilan.slManager != undefined ? bilan.slManager.firstName : "";
              var managerLastName =
                bilan.slManager != undefined ? bilan.slManager.lastName : "";
              bilan.manager = managerFirstName + " " + managerLastName;
            });

            this.originalBilans = this.bilans;
            this.puntInPlural();
          }
        });
    },
  },
  mounted: function() {
    fetch(process.env.VUE_APP_ROOT_API_PATH + "api/campaingsBilan", {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        if (response.status == "200") {
          return response.json();
        }
      })
      .then((json) => {
        this.campaignsBilans = json.data;
        for (var i = 0; i < this.campaignsBilans.length; i++) {
          var campaignBilan = this.campaignsBilans[i];
          this.campaignsItems.push({
            text:
              campaignBilan.year +
              " (" +
              campaignBilan.startPeriod +
              " - " +
              campaignBilan.endPeriod +
              ")",
            value: campaignBilan.year,
          });
        }

        if (this.campaignsBilans.length >= 1) {
          this.loadBilans();
        }
      });
  },
};
</script>
<style>
.margin-top {
  margin-top: 10px;
}

.no-margin {
  margin: 0 !important;
}

.card {
  height: 100vh !important;
}
</style>
